<div id="ivsig" class="position-relative" *ngIf="showTemplate" [style.width]="!external ? ivSignModalWidth : IvDeskModalWidth">
    <div *ngIf="!external">
        <div class="text-center" id="titleCustom" *ngIf="customText">
            <div class="titleText">{{customText}}</div>
              <img src="assets/images/logoIvsign.png" alt="IvSign">
        </div>

        <div class="text-center" id="titleDefault" *ngIf="!customText">
          <img src="assets/images/logoIvsign.png" alt="IvSign">
        </div>

        <div class="ivSignModal" *ngIf="!noCert" [style.width]="valCertLoad ? '27rem' : '100%'" >
            <iv-form #ivform [errorsForm]="errorMessages" [(columnsForm)]="form" [color]="color" [textColor]="textColor"
                [inModal]="true" (onEnterKey)="login();" [buttons]="null"></iv-form>
        </div>
        <div class="ivSignModal text-center" *ngIf="noCert">
            {{ 'ivsign_message_nocertificate' | translate  }}
        </div>
    </div>

    <div *ngIf="external && !valCertLoad" class="text-center">
        <p class="link" [innerHTML]="(('tareasusuario_ivdesk_modal'| translate) + ' ' + ('tareasusuario_ivdesk_modal_2'| translate))">
        </p>
          <a class="primary-color font-weight-bold" href="{{ivDeskLink}}" target="_blank" title="IvDesk">IvDesk</a>
    </div>

    <iv-loading id="ivloading-modal" [diameter]="30" [strokeWidth]="3" [hidden]="!loading" [fullScreen]="true">
    </iv-loading>
</div>
